import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit, signal, Signal } from '@angular/core'
import { FormGroup } from '@angular/forms';
import { OrderWizardService } from '../../../_service/order-wizard.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'itsme-login-button',
    templateUrl: './itsme-login-button.component.html',
    styleUrls: ['./itsme-login-button.component.scss'],
    imports: [TranslateModule],
})
export class OrderWizardItsMeLoginComponent implements OnInit {
    form: FormGroup | null = null;
    private http = inject(HttpClient);
    redirectUrl = signal('url not set');
    userinfo = signal('Anonymous');

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;
    }
    
    ngOnInit(): void {
        this.http.get(`api/itsme/login/initiate`, { responseType: 'text' }).subscribe((response: string) => {
            this.redirectUrl.set(response);
        });
    }

    public redirect() {
        window.location.href = this.redirectUrl();
    }
}